import { render, staticRenderFns } from "./sort-modal.vue?vue&type=template&id=5bcc84d0&"
import script from "./sort-modal.vue?vue&type=script&lang=js&"
export * from "./sort-modal.vue?vue&type=script&lang=js&"
import style0 from "./sort-modal.vue?vue&type=style&index=0&id=5bcc84d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports